import 'mapbox-gl/dist/mapbox-gl.css';

export default defineNuxtPlugin(() => {
  // CSS is imported above
});
